import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { IframeComponent } from './iframe/iframe.component';
import { isLoginInGuard } from '@guards/isLogin.guard';
import { NotFoundComponent } from './404/404.component';
import { commentDataResolver } from '@shared/resolvers/comment/comment-data.resolver';
import { packDataResolver } from '@shared/resolvers/pack/pack-data.resolver';
import { HomeGuard } from '@guards/home.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '404', component: NotFoundComponent },
  { path: 'clients', loadChildren: () => import('./clients/clients.module').then((m) => m.ClientsModule), canActivate: [isLoginInGuard] },
  { path: 'recipes', loadChildren: () => import('./recipes/recipes.module').then((m) => m.RecipesModule), canActivate: [isLoginInGuard] },
  { path: 'users', loadChildren: () => import('./users/users.module').then((m) => m.UsersModule), canActivate: [isLoginInGuard] },
  {
    path: 'slideshows',
    canActivate: [isLoginInGuard],
    loadChildren: () => import('./slideshows/slideshows.module').then((m) => m.SlideshowsModule),
  },
  {
    path: 'administration',
    canActivate: [isLoginInGuard],
    loadChildren: () => import('./administration/administration.module').then((m) => m.AdministrationModule),
  },
  {
    path: 'contents',
    loadChildren: () => import('./contents/contents.module').then((m) => m.ContentsModule),
    canActivate: [isLoginInGuard],
  },
  {
    path: 'communities-recipes',
    loadChildren: () => import('./communities-recipes/communities-recipes.module').then((m) => m.CommunitiesRecipesModule),
    canActivate: [isLoginInGuard],
  },
  {
    path: 'partners',
    loadChildren: () => import('./partners/partners.module').then((m) => m.PartnersModule),
    canActivate: [isLoginInGuard],
  },
  {
    path: 'references/packs',
    loadChildren: () => import('./packs/packs.module').then((m) => m.PacksModule),
    resolve: {
      packData: packDataResolver,
    },
    canActivate: [isLoginInGuard],
  },
  {
    path: 'references/techniques',
    loadChildren: () => import('./techniques/techniques.module').then((m) => m.TechniquesModule),
    canActivate: [isLoginInGuard],
  },
  {
    path: 'users/search',
    loadChildren: () => import('./users/users.module').then((m) => m.UsersModule),
    canActivate: [isLoginInGuard],
  },
  {
    path: 'home',
    canActivate: [isLoginInGuard, HomeGuard],
    pathMatch: 'full',
    children: [],
  },
  {
    path: 'moderation',
    loadChildren: () => import('./moderation/moderation.module').then((m) => m.ModerationModule),
    resolve: {
      commentData: commentDataResolver,
    },
    canActivate: [isLoginInGuard],
  },
  {
    path: '**',
    component: IframeComponent,
    canActivate: [isLoginInGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
